var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-card',{staticClass:"transparentBack",staticStyle:{"max-width":"min(460px, calc(100vw - 30px))"},attrs:{"elevation":hover ? 10 : 6,"to":!_vm.admin ? _vm.link : ''}},[_c('v-img',{staticClass:"fotoHolder",attrs:{"width":"100%","height":"140","src":_vm.imgSrc,"position":"bottom center"}}),_c('v-sheet',{staticClass:"pa-4 backgroundGradient",class:{ sameHeight: !_vm.admin }},[(_vm.admin)?_c('v-text-field',{staticClass:"py-2",attrs:{"label":_vm.label},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}):_c('v-card-title',{staticClass:"py-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.admin)?_c('tinyMCE',{attrs:{"init":{
          content_css: false,
          skin: false,
          setup: function (ed) {
            ed.on('init', function () {
              this.getDoc().body.style.fontSize = '12';
              this.getDoc().body.style.fontFamily = 'Roboto, sans-serif';
            });
          },
          statusbar: false,
          height: 300,
          menubar: false,
          language_url: '/langs/de.js',
          language: 'de',
          block_formats: 'Text=p; Überschrift 1=h1; Überschrift 2=h2',
          plugins: ['lists', 'link', 'paste'],
          paste_as_text: true,
          default_link_target: '_blank',
          toolbar:
            'undo redo | bold italic underline | link | bullist numlist outdent indent | formatselect | removeformat',
        }},model:{value:(_vm.bottomText),callback:function ($$v) {_vm.bottomText=$$v},expression:"bottomText"}}):_c('v-card-text',{on:{"click":e => e.stopPropagation()}},[_c('span',{class:{
            barrierefrei: _vm.$route.query.barrierefrei,
          },domProps:{"innerHTML":_vm._s(_vm.bottomText)}})])],1)],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }